import { render, staticRenderFns } from "./TreeCollection.vue?vue&type=template&id=47497ae4&scoped=true&"
import script from "./TreeCollection.vue?vue&type=script&lang=js&"
export * from "./TreeCollection.vue?vue&type=script&lang=js&"
import style0 from "./TreeCollection.vue?vue&type=style&index=0&id=47497ae4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47497ae4",
  null
  
)

export default component.exports